import React from "react";
import { injectIntl } from "react-intl";
import { useRouteMatch, Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { compose } from "recompose";
import { Typography } from "@material-ui/core";
import {} from "../../../utilities/constants";
import MoreVertIcon from "@material-ui/icons/MoreVert";
const LanguageNavigator = ({ language }) => {
  const match = useRouteMatch();

  return (
    <Grid
      container
      justify="space-between"
      alignItems="center"
      style={{ minHeight: "100px" }}
    >
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            {language && (
              <Typography
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  wordBreak: "break-word",
                  fontSize: "13px",
                  lineHeight: "16px",
                  letterSpacing: "2.08px",
                  fontWeight: "400",
                  color: "inherit",
                }}
              >
                {language && language.label}
              </Typography>
            )}
          </Grid>
          <Grid item>
            {language && language.id !== 1 && language.percentComplete >= 0 && (
              <Typography
                variant="subtitle2"
                style={{
                  textAlign: "left",
                  wordBreak: "break-word",
                  fontSize: "13px",
                  lineHeight: "16px",
                  letterSpacing: "2.08px",
                  fontWeight: "400",
                  color: "inherit",
                }}
              >
                {language.percentComplete.toFixed(0)}% &nbsp;Translated
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const enhance = compose(injectIntl);

export default enhance(LanguageNavigator);
